export const PRIORITY_INCIDENTS_FILTER_TYPES = [
    { _id: 1, name: 'LOW' },
    { _id: 2, name: 'MEDIUM' },
    { _id: 3, name: 'HIGH' },
]
